import Layout from '../components/Layout';
import MainBanner from '../components/MainBanner';
import PhotoCarousel from '../components/PhotoCarousel';
import HowItWorksSection from '../components/HowItWorksSection';
import AboutSection from '../components/AboutSection';
import BenefitsSection from '../components/BenefitsSection';
import CombineSection from '../components/CombineSection';
import ReviewSection from '../components/ReviewSection';
import UnderstandSection from '../components/UnderstandSection';

function Index() {
  return (
    <Layout>
      <MainBanner />
      <PhotoCarousel />
      <HowItWorksSection />
      <AboutSection />
      <BenefitsSection />
      <CombineSection />
      <ReviewSection />
      <UnderstandSection />
    </Layout>
  );
}

export default Index;
